import { type ButtonTypes } from "@msidentity/SISU/components/button/button-interface-fabric";
import { type MemberNameType } from "@msidentity/SISU/model/user";

export type UsernameRecoveryMemberNamePrefill = MemberNameType.EASI | MemberNameType.Phone;

export type UsernameRecoveryButtonProps = {
  id: string;
  label: string;
  handler: (event: React.SyntheticEvent) => void;
  type: ButtonTypes;
  disabled: boolean;
};
export type UsernameRecoveryViewProps = {
  title: string;
  description: string;
  cancelButton: UsernameRecoveryButtonProps;
  submitButton: UsernameRecoveryButtonProps;
};

export type UsernameRecoveryGenericStrings = {
  title: string;
  tryAgain: string;
  learnMore: string;
  errorGeneric: string;
  errorExpiredCreds: string;
  cancel: string;
  back: string;
  next: string;
  signin: string;
  genericServiceError: string;
  easiSwitchLink: string;
  temporaryProblem: string;
};

export const UsernameRecoveryResultAliasType = {
  Email: "email",
  Phone: "phone",
} as const;

export type ResultAliasTypeValues =
  (typeof UsernameRecoveryResultAliasType)[keyof typeof UsernameRecoveryResultAliasType];

export type RecoveryAlias = {
  name: string;
  isUnmasked: boolean;
  type: ResultAliasTypeValues;
};
